export default {
  defaultError: 'An error has occured, please try again later',
  'ff.error.loadFailed': 'Failed to load items'
}